module.exports = __webpack_public_path__ + "img/forgot-password.750f5b7c.jpg";